import React, { useEffect } from 'react';
import layoutStyles from './index.module.scss';
import RatRaceNav from './Nav';
import RatRaceHero from './Hero';
import RatRaceDistance from './Distance';
import RatRaceMotivation from './Motivation';
import RatRaceHowItWorks from './HowItWorks';
import RatRaceFAQ from './FAQ';
import RatRaceFooter from './Footer';

export default function RatRaceLanding({ policyBasePath }) {
  useEffect(() => {
    document.body.classList.add(layoutStyles.mobileScrollLock);

    return () => document.body.classList.remove(layoutStyles.mobileScrollLock);
  }, []);

  return (
    <div className={layoutStyles.page}>
      <RatRaceNav />
      <RatRaceHero />
      <RatRaceDistance />
      <RatRaceMotivation />
      <RatRaceHowItWorks />
      <RatRaceFAQ />
      <RatRaceFooter policyBasePath={policyBasePath} />
    </div>
  );
}
